"use client";

import React from "react";
import { ArrowRight, MessageCircle } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { EcommerceProductsProvider, useEcommerceProducts } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function CakesCarouselConsumer() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div className="w-full h-[600px] flex items-center justify-center">
        <div className="text-muted-foreground animate-pulse">Caricamento torte d'autore...</div>
      </div>;
  }
  if (error) {
    return <div className="w-full py-20 text-center text-destructive">
        Si è verificato un errore nel caricamento delle torte. Riprova più tardi.
      </div>;
  }
  if (products.length === 0) {
    return <div className="w-full py-20 text-center text-muted-foreground">
        Nessuna torta disponibile al momento.
      </div>;
  }
  return <Carousel opts={{
    align: "start",
    loop: true
  }} className="w-full">
      <CarouselContent>
        {products.map((product, i) => <CarouselItem key={product.id} data-index={i} className="basis-full">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
              {}
              <div className="relative aspect-[3/4] lg:aspect-[4/5] w-full overflow-hidden rounded-xl shadow-xl">
                {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="h-full w-full object-cover transition-transform duration-700 hover:scale-105" loading="lazy" /> : <div className="h-full w-full bg-secondary/50 flex items-center justify-center text-muted-foreground">
                    Immagine non disponibile
                  </div>}
              </div>

              {}
              <div className="flex flex-col justify-center space-y-6 lg:pr-12 text-center lg:text-left">
                <div className="space-y-4">
                  <h3 className="text-3xl md:text-4xl lg:text-5xl font-serif font-medium text-primary leading-tight">
                    {product.title}
                  </h3>
                  <div className="w-24 h-1 bg-primary/20 mx-auto lg:mx-0 rounded-full" />
                </div>

                {product.short_description && <div className="text-base md:text-lg text-muted-foreground leading-relaxed prose prose-stone max-w-none font-sans" dangerouslySetInnerHTML={{
              __html: product.short_description
            }} />}

                <div className="pt-4 flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                  <Link to={`https://wa.me/+393402498369?text=Salve, vorrei un preventivo per la torta: ${encodeURIComponent(product.title)}`} newTab>
                    <Button size="lg" className="w-full sm:w-auto px-8 py-6 text-lg rounded-full shadow-lg hover:shadow-xl transition-all">
                      <MessageCircle className="mr-2 h-5 w-5" />
                      Richiedi Preventivo
                    </Button>
                  </Link>
                  
                  <Link to={product.link}>
                    <Button variant="outline" size="lg" className="w-full sm:w-auto px-8 py-6 text-lg rounded-full border-primary/20 hover:bg-primary/5">
                      Dettagli Torta
                      <ArrowRight className="ml-2 h-5 w-5" />
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </CarouselItem>)}
      </CarouselContent>
      
      {}
      <div className="hidden lg:block">
        <CarouselPrevious className="left-4 bg-background/80 backdrop-blur-sm border-none shadow-md hover:bg-background" />
        <CarouselNext className="right-4 bg-background/80 backdrop-blur-sm border-none shadow-md hover:bg-background" />
      </div>

      {}
      <div className="block lg:hidden">
        <CarouselPrevious className="left-2 bg-background/80 backdrop-blur-sm border-none shadow-md hover:bg-background" />
        <CarouselNext className="right-2 bg-background/80 backdrop-blur-sm border-none shadow-md hover:bg-background" />
      </div>
      
    </Carousel>;
}
export default function VetrinaDelleTorteDautore() {
  const wp_query_params = {
    post_type: "product",
    per_page: 6,
    product_cat: "20",
    orderby: "date",
    order: "desc",
    status: "publish"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="vetrina-delle-torte-dautore" className="py-20 lg:py-32 bg-muted relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-64 h-64 bg-primary/5 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2 pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-primary/5 rounded-full blur-3xl translate-x-1/3 translate-y-1/3 pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-16 space-y-4">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-primary">Torte su Ordinazione, create per i tuoi momenti speciali</h2>
          <p className="text-lg text-muted-foreground font-sans">Ogni occasione merita una torta speciale.<div>Realizziamo torte su ordinazione, curate nei dettagli e preparate con ingredienti di qualità.</div></p>
        </div>

        <EcommerceProductsProvider wp_query={wp_query} className="w-full max-w-6xl mx-auto">
          <CakesCarouselConsumer />
        </EcommerceProductsProvider>
      </div>
    </section>;
}